import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { footerData } from '../data/mock';

const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-gradient-to-br from-red-600 to-red-700 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">M</span>
              </div>
              <div>
                <h3 className="text-xl font-bold">{footerData.company}</h3>
                <p className="text-xs text-gray-400">{footerData.tagline}</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              {footerData.description}
            </p>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Company</h4>
            <ul className="space-y-3">
              {footerData.links.company.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-gray-400 hover:text-red-500 transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Products Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Products</h4>
            <ul className="space-y-3">
              {footerData.links.products.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-gray-400 hover:text-red-500 transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Support</h4>
            <ul className="space-y-3">
              {footerData.links.support.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-gray-400 hover:text-red-500 transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              {footerData.copyright}
            </p>
            <div className="flex items-center space-x-6">
              <button className="text-gray-400 hover:text-red-500 transition-colors duration-200 text-sm">
                Privacy Policy
              </button>
              <button className="text-gray-400 hover:text-red-500 transition-colors duration-200 text-sm">
                Terms of Service
              </button>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-wrap justify-center items-center gap-8">
            <div className="text-center">
              <p className="text-2xl font-bold text-red-500">45+</p>
              <p className="text-xs text-gray-400">Years Experience</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold text-red-500">30+</p>
              <p className="text-xs text-gray-400">Countries</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold text-red-500">5000+</p>
              <p className="text-xs text-gray-400">Products</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold text-red-500">100%</p>
              <p className="text-xs text-gray-400">Authentic</p>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-8 p-4 bg-gray-800 rounded-lg">
          <p className="text-xs text-gray-400 text-center leading-relaxed">
            <span className="font-semibold text-gray-300">Medical Disclaimer:</span> This website is for informational purposes only. 
            Always consult with a qualified healthcare professional before starting any medication. 
            MediSeller is a licensed international pharmacy operating in compliance with all applicable regulations.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
